<template>
  <div>
        <div class="row">
          <div class="col s12" style="line-height: 2.5;">{{$t('bases.maintenaces')}}</div>
        </div>
        <div class="row">
          <div class="col s12" style="line-height: 2.5; margin-bottom: 15px;">
             <label>
              <input type="checkbox" v-model="substance_replaced"/>
              <span>{{$t('inspection.replace_letter')}}</span>
            </label>
             <label>
              <input type="checkbox" v-model="cleanup"/>
              <span>{{$t('inspection.cleanup_letter')}}</span>
            </label>
             <label v-for="maintenace in dev_type.maintenaces" :title="maintenace.text">
              <input type="checkbox" :id="'maintenace'+uid+'id'+maintenace.id" :value="maintenace.id" v-model="property.maintenace_ids"/>
              <span>{{maintenace.symbol}}</span>
            </label>
          </div>
        </div>
        <div class="row">
          <div class="col s2" style="line-height: 2.5; text-align: right; text-transform: uppercase;">{{$t('inspection.activity')}}</div>
          <div class="col s8">
             <select v-model="conditions" :disabled="property.method != 'standard'">
               <option v-for="(actlevel, index) in long_act_levels" :value="index">{{actlevel}}</option>
             </select>
          </div>
        </div>
         <div class="row" v-if="property.method == 'logic_value'">
          <div class="col s2" style="line-height: 2.5; text-align: right; text-transform: uppercase;">{{$t('inspection.catched')}}</div>
          <div class="col s8">
            <label>
             <input type="checkbox" v-model="property.catched"/>
              <span>{{$t('inspection.catched')}}</span>
           </label>
          </div>
        </div>
        <div class="row" v-if="conditions > 0 && property.method != 'pests_quantity'">
          <div class="col s2" style="line-height: 2.5; text-align: right; text-transform: uppercase;">{{$t('inspection.pests')}}</div>
          <div class="col s8">
              <selectpests
                v-model="property.property_pests"
                :items="pests"
                groupitems="items"
                :identifier="'pestslist'+uid"
                :recommendations="dev_type.pests"
              />
          </div>
        </div>
        <div class="row" v-if="property.method == 'pests_quantity'">
          <div class="col s2" style="line-height: 2.5; text-align: right;">{{$t('inspection.pests')}}</div>
          <div class="col s8">
              <selectpestquantities
                v-model="property.property_pests"
                :items="pests"
                groupitems="items"
                :identifier="'pestslist'+uid"
                :recommendations="dev_type.pests"
              />
          </div>
        </div>
        <div class="row">
          <div class="col s2" style="line-height: 2.5; text-align: right;">{{$t('inspection_summary.substances')}}</div>
          <div class="col s8" >
             <selector
                v-if="!substanceUsages && property.method != 'substance_consumed'"
                v-model="substance_ids"
                :items="substances"
                groupitems="items"
                :recommendations="dev_type.substance_ids"
                :identifier="'substanceslist'+uid"
             />
             <selectdosages
                v-model="property.dosages"
                v-if="substanceUsages || property.method == 'substance_consumed'"
                :items="substances"
                groupitems="items"
                :identifier="'substancesextlist'+uid"
                :recommendations="dev_type.substance_ids"
                :withConsumption="property.method == 'substance_consumed'"
             />
          </div>
        </div>
        <div class="row" v-if="property.method == 'substance_consumed'">
          <div class="col s2" style="line-height: 2.5; text-align: right;">{{$t('inspection.substance_consumption')}}</div>
          <div class="col s8">
             <p class="range-field">
                  <input type="range" v-model="property.consumed" id="consumed" min="0" :max="100" />
              </p>
              <p>{{property.consumed}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col s3" style="line-height: 2.5;">{{$t('inspection.safety_conditions')}}</div>
        </div>
        <div class="row">
          <div class="col s12">
            <fieldset>
               <label>
                <input :name="uid" id="good" value="good" type="radio" v-model="safety_conditions_val"/>
                <span>{{$t('inspection.safety_conditions_good')}}</span>
              </label>
               <label>
                <input :name="uid" id="broken" value="broken" type="radio" v-model="safety_conditions_val"/>
                <span>{{$t('inspection.safety_conditions_broken')}}</span>
              </label>
               <label>
                <input :name="uid" id="need_replace" value="need_replace" type="radio" v-model="safety_conditions_val"/>
                <span>{{$t('inspection.safety_conditions_need_replace')}}</span>
              </label>
            </fieldset>
          </div>
        </div>
        <div class="row">
          <div class="col s2"><button class="btn-small solidgreen" v-on:click="addPhoto()">{{$t('inspection.add_photo')}}</button></div>
        </div>
        <div class="row" style="margin-top: 25px;">
          <div class="col s2" v-for="(photo, index) in property.media" v-if="photo._destroy != true" style="width: fit-content;margin: auto;height: 100px;">
            <button class="removephoto" v-on:click="removePhoto(photo)"><i class="material-icons">close</i></button>
            <div style="width: fit-content; margin: auto;">
                <img style="max-height: 80px" v-if="photo.image" :src="photo.image" />
                <img :class="'photo'+index" style="max-height: 80px" v-if="photo.image == undefined"/>
            </div>
            <p>{{photo.notices}}</p>
              <input
                v-if="photo.image == undefined"
                type="file"
                id="photo"
                name="photo"
                multiple="true"
                @change="setFile(photo, $event.target.name, $event.target.files)"
                accept="image/png, image/jpeg"
             />
          </div>
        </div>
        <div class="row" style="margin-top: 25px;">
          <div class="col s12">
            <textarea v-model="notions" :placeholder="$t('inspection.notices')"></textarea>
          </div>
        </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      long_act_levels: [this.$t('devices.no_activity'), this.$t('devices.low_activity'), this.$t('devices.average_activity'), this.$t('devices.high_activity'), this.$t('devices.very_high_activity')],
      device_conditions_levels: ["", this.$t('inspection.safety_conditions_good'), this.$t('inspection.safety_conditions_broken'), this.$t('inspection.safety_conditions_need_replace')],
      criteria_dict: {},
      criterium: {},
      uid: _.uniqueId("deviceInspection"),
      substance_replaced: false,
      cleanup: false,
      conditions: 0,
      safety_conditions: 0,
      pest_ids: [],
      notions: "",
      substance_ids: []
    }
  },
  watch:{
    'property.dosages':{
      handler: function(newVal){
        console.log(pct);
        if(this.criterium.method == "substance_consumed"){
          var pct = this.dosesPercentage;
          this.property.consumed = pct;
          console.log(pct);
        }
      },
      deep: true
    },
    'property.consumed':{
      handler: function(newVal){
        if(this.criterium.method == "substance_consumed"){
          var pct = newVal;
          if(pct == 0){
            this.conditions = 0;
          }else if(pct <= this.criterium.medium_activity_thresold){
            this.conditions = 1;
          }else if(pct <= this.criterium.high_activity_thresold){
            this.conditions = 2;
          }else if(pct <= this.criterium.very_high_activity_thresold){
            this.conditions = 3;
          }else if(pct >= this.criterium.very_high_activity_thresold){
            this.conditions = 4;
          }
        }
      },
      deep: true
    },
    'property.property_pests':{
      handler: function(newVal){
        if(this.criterium.method == "pests_quantity"){
          var sum = 0;
          if(newVal != undefined){
            for (var i = newVal.length - 1; i >= 0; i--) {
              sum += newVal[i].quantity;
            }
          }
          if(sum == 0){
            this.conditions = 0;
          }else if(sum <= this.criterium.medium_activity_thresold){
            this.conditions = 1;
          }else if(sum <= this.criterium.high_activity_thresold){
            this.conditions = 2;
          }else if(sum <= this.criterium.very_high_activity_thresold){
            this.conditions = 3;
          }else if(sum >= this.criterium.very_high_activity_thresold){
            this.conditions = 4;
          } 
        }
      },
      deep: true
    },
    'property.catched':{
      handler: function(newVal){
        if(newVal){
          this.conditions = 4;
        }else{
          this.conditions = 0;
        }
      },
      deep: true
    },
  },
  props: {
    property: Object, 
    pestGroups: Object, 
    substanceGroups: Object, 
    substanceUsages: Boolean, 
    withSeal: Boolean, 
    dev_type: Object,
    device: Object,
    criteria: Array,
  },
  mounted() {
    this.property.method = this.property.method || this.property.current_method;
    this.substance_replaced = this.property.substance_replaced;
    this.cleanup = this.property.cleanup;
    this.conditions = this.property.conditions;
    this.safety_conditions = this.property.safety_conditions;
    this.notions = this.property.notions;
    this.substance_ids = this.property.substance_ids;
    this.pest_ids = this.property.pest_ids;
    for (var i = this.criteria.length - 1; i >= 0; i--) {
      var zone = this.criteria[i];
      this.criteria_dict[zone.zone_id]={};
      for (var j = zone.categories.length - 1; j >= 0; j--) {
        this.criteria_dict[zone.zone_id][zone.categories[j].id] = zone.categories[j];
      }
    }
    this.criterium = this.criteria_dict[""+this.device.zone_id]  != undefined ? this.criteria_dict[""+this.device.zone_id][""+this.device.dev_category] : undefined;
    this.property.media ||= [];
  },
  methods: {
    setgood(){
      this.good = true;
      this.$forceUpdate();
    },
    setbroken(){
      this.broken = true;
      this.$forceUpdate();
    },
    setneedreplace(){
      this.need_replace = true;
      this.$forceUpdate();
    },
    addPhoto(){
      this.property.media.push({notices: ""});
      this.$forceUpdate();
    },
    removePhoto(photo) {
        if (_.isUndefined(photo.id)) {
            this.property.media.splice(this.property.media.indexOf(photo), 1)
        } else {
            photo._destroy = true;
        }
         this.$forceUpdate();
    },
    apply(){
      this.property.cleanup = this.cleanup;
      this.property.substance_replaced = this.substance_replaced;
      this.property.conditions = this.conditions;
      this.property.safety_conditions = this.safety_conditions;
      this.property.notions = this.notions;
      this.property.substance_ids = _.uniq(this.substance_ids);
      this.property.pest_ids = _.uniq(this.pest_ids);
    },
    setFile: function(doc, name, file) {
            var that = this;

            doc.image = file[0];
            var reader = new FileReader();

            reader.onload = function(event) {
                var dataUri = event.target.result;
                var img = document.getElementsByClassName('photo' + that.property.media.indexOf(doc))[0];

                img.src = dataUri;
            };
            reader.onerror = function(event) {
            };
            reader.readAsDataURL(doc.image);
            if (file.length > 1) {
                for (var i in _.range(file.length)) {
                    if (i > 0) {
                        var ndoc = { timestamp: _.now() };
                        ndoc.image = file[i];
                        var reader = new FileReader();

                        reader.onload = function(event) {
                            var dataUri = event.target.result;
                            var img = document.getElementsByClassName('photo' + that.property.media.indexOf(ndoc))[0];
                            img.src = dataUri;
                        };
                        reader.onerror = function(event) {
                        };
                        reader.readAsDataURL(ndoc.image);

                        this.property.media.push(ndoc)
                    }
                }
            }

        },
  },
  computed: {
    pestsDict(){
      return  _.toPairs(this.pestGroups).map(function(para){
        return para[1].map(function(pest){
            return {id: pest.id, name: pest.name};
          })
      });
    },
    pests(){
      return  _.toPairs(this.pestGroups).map(function(para){
        return {
          name: para[0],
          items: para[1].map(function(pest){
            return {id: pest.id, name: pest.name};
          })
        }
      });
    },
    substances(){
      return  _.toPairs(this.substanceGroups).map(function(para){
        return {
          name: para[0],
          items: para[1].map(function(substance){
            return {id: substance.id, name: substance.name, unit: substance.default_unit};
          })
        }
      });
    },
    dosesPercentage(){
      var sum = 0;
      var doseSum = 0;
      for (var i = this.property.dosages.length - 1; i >= 0; i--) {
        var dose = this.property.dosages[i];
        var dos = parseInt(dose.dosage);
        if(dos != null && dos != undefined){
          sum = sum + parseInt(dose.consumed);
          doseSum = doseSum + dos;
        }
      }
      if(doseSum == 0) return 0;
      else return (sum * 100) / doseSum;
    },
    good: {
      get: function(){
        return this.safety_conditions == 3;
      },
      set: function(newVal){
        if(newVal){
          this.safety_conditions = 3
        }
      }
    },
    broken: {
      get: function(){
        return this.safety_conditions == 2;
      },
      set: function(newVal){
        if(newVal){
          this.safety_conditions = 2
        }
      }
    },
    need_replace: {
      get: function(){
        return this.safety_conditions == 1;
      },
      set: function(newVal){
        if(newVal){
          this.safety_conditions = 1
        }
      }
    },
    safety_conditions_val: {
      get: function(){
       return ["need_replace", "broken", "good"][this.safety_conditions - 1 ]
      },
      set: function(newVal){
        this.safety_conditions = ["need_replace", "broken", "good"].indexOf(newVal) + 1
        this.$forceUpdate()
      }
    }
  }
}
</script>
<style scoped>
  select {
    display: block;
  }
  .modal{
    border: 5px solid #00CC66;
    border-radius: 15px;
  }
  h5{
    font-size: 15px;
    text-transform: uppercase;
  }
  label{
    padding: 10px;
    margin: 5px;
    border: 2px solid rgb(140, 140, 140);
    border-radius: 5px;
  }
  label:has(input:checked){
    border: 2px solid #00CC66 !important;
  }
  [type="checkbox"]+span:not(.lever):before {
      top: 0px;
      left: 0px;
      margin: 4px;
      width: 16px;
      height: 16px;
      border: 2px solid rgb(140, 140, 140);
      border-radius: 50%;
      -webkit-transform: rotate(40deg);
      transform: rotate(0deg) !important;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform-origin: 100% 100%;
      transform-origin: 100% 100%;
  }
  [type="checkbox"]:checked+span:not(.lever):before {
      top: 0px;
      left: 0px;
      border: 2px solid #00CC66;
      line-height: 12px;
      font-family: 'Material Icons';
      color: #00CC66;
      content: "\e5ca";
      border-radius: 50%;
      -webkit-transform: rotate(40deg);
      transform: rotate(0deg) !important;
      -webkit-backface-visibility: hidden;
      backface-visibility: hidden;
      -webkit-transform-origin: 100% 100%;
      transform-origin: 100% 100%;
      font-size: 12px;
  }
  [type="radio"]:checked+span:after{
    border: 2px solid #00CC66;
    background-color: #fff;
    font-family: 'Material Icons';
    color: #00CC66;
    content: "\e5ca";
    line-height: 12px;
    font-size: 12px;
  }
  fieldset{
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 5px;
  }
  .removephoto {
      vertical-align: top;
      float: right;
      background-color: black;
      border: none;
      border-radius: 15px;
  }
  .removephoto i {
      color: white;
  }
  /deep/ .select-dropdown{
    max-height: 50vh;
  }
</style>
